import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['searchBox'];

  connect() {
    this.params = {};
    this.params['query'] = null;
  }

  submitSearch(e) {
    e.preventDefault();
    const query = this.searchBoxTarget.value.trim();
    if (query.length > 0 && this.params['query'] != query) {
      this.params['query'] = query;
      this.fetchStaffMembers();
    }
  }

  changeSearchInput(e) {
    if (e.which == 13) {
      const query = this.searchBoxTarget.value.trim();
      if (query.length > 0 && this.params['query'] != query) {
        this.params['query'] = query;
        this.fetchStaffMembers();
      }
    } else if (e.which == 8) {
      const query = this.searchBoxTarget.value.trim();
      if (query.length == 0) {
        this.params['query'] = null;
        this.fetchStaffMembers();
      }
    }
  }

  fetchStaffMembers() {
    let url = `/staff_members`;
    if (this.params.query) {
      url += `?q=${this.params.query}`;
    }
    window.location = url;
  }
}
